import { render, staticRenderFns } from "./FactoringNovedadesNoticiaMensual.vue?vue&type=template&id=44570c83"
import script from "./FactoringNovedadesNoticiaMensual.vue?vue&type=script&lang=js"
export * from "./FactoringNovedadesNoticiaMensual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports